import { createSelector } from '@reduxjs/toolkit';
import { getRightsList } from '../../../../../redux/rights/selectors';
import { Role } from '../roles';

export const isSCCCustomer = createSelector(getRightsList, (rightsList) =>
  rightsList.some((right) => right.name === Role.SCCCustomer)
);
export const isSCCService = createSelector(getRightsList, (rightsList) =>
  rightsList.some((right) => right.name === Role.SCCService)
);
